<template>
  <div class="inspection">
    <div class="cnt">
      <h1>
        <img src="@/assets/img/icon/logo_red.png" alt="giftshow biz" />
        <strong>{{ systemBlockInfo.blockMgmtSubject }}</strong>
      </h1>
      <strong>더 나은 서비스를 제공하기 위하여 서비스 접속이 일시 중단됩니다.</strong>

      <p v-html="systemBlockInfo.blockMgmtContent" />

      <div>
        <dl>
          <dt>점검 시간</dt>
          <dd>
            {{ systemBlockInfo.blockStartDate | formatDate('YYYY-MM-DD HH:mm') }} ~
            {{ systemBlockInfo.blockEndDate | formatDate('YYYY-MM-DD HH:mm') }}
          </dd>
        </dl>
        <dl>
          <dt>점검 영향</dt>
          <dd>점검 시간 동안 사이트 이용 불가</dd>
        </dl>
      </div>

      <p>점검시간은 예정보다 단축되거나 지연될 수 있습니다.<br>서비스 이용에 불편을 드려 대단히 죄송합니다.</p>
    </div>
    <p class="copy">Copyright ⓒ kt alpha Co., Ltd. All rights reserved</p>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters(['systemBlockInfo']),
  },
};
</script>

<style>
</style>
